import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { EmptySearchList } from '../../../components/empty-search-list/index';
import { PaginationController } from '../../../components/pagination-controller/index';
import { itemsToFetchMap } from '../../share-classes/share-classes.types';
import { StakeholderItem } from '../stakeholder-item';
import StakeholderTable from '../stakeholder-table/index';
import { StakeholdersCardComponentProps } from '../stakeholders';

export type StakeholdersCardProps = StakeholdersCardComponentProps;

export const StakeholdersCard: FC<StakeholdersCardProps> = ({
  currentPage,
  handlePageChange,
  totalPages,
  itemsToFetch,
  onFetchAmountChange,
  ...props
}) => {
  const { searchValue: search, data } = props;

  return (
    <>
      {search && data?.length === 0 ? (
        <div
          className={twMerge(
            'flex h-fit w-full flex-wrap items-center justify-center gap-4 px-4 pt-4',
          )}
        >
          <EmptySearchList className="my-20" />
        </div>
      ) : (
        <>
          <StakeholderTable {...props} />
          <div
            className={twMerge(
              'flex h-fit w-full flex-wrap justify-center gap-4 px-4 pt-4 lg:hidden',
              search && data?.length === 0 && 'items-center',
            )}
          >
            {data?.map((stakeholderData) => (
              <StakeholderItem {...props} {...stakeholderData} key={stakeholderData.id} />
            ))}
          </div>
        </>
      )}

      <PaginationController
        className="shrink-0 max-lg:px-4 lg:mx-6"
        currentPage={currentPage}
        itemsToFetch={itemsToFetch}
        itemsToFetchMap={itemsToFetchMap}
        onClick={handlePageChange}
        onFetchAmountChange={onFetchAmountChange}
        totalPages={totalPages || 0}
      />
    </>
  );
};
